export enum CoinTypeEnum {
  FREE = 'FREE',
  PAID = 'PAID',
}
